class VariantOptions extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.getElementsByTagName('label')[0].click();
    this.getSelectedColor();
    this.filterMedia();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.filterMedia();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
      this.getSelectedColor();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }
  getColorsOptionInfo(){
    this.variantInfo = this.variantInfo || JSON.parse(this.querySelector('#variants-info').textContent);
    this.variantInfo.forEach((variant) => {
      if(variant.name.toLowerCase().includes('color')){
        this.colorsInOption = JSON.parse(JSON.stringify(variant.values));
      }
    });
    return this.colorsInOption;
  }

  getSelectedColor(){
    var currentSelectedColor;
    if(this.querySelector('.rounded')){
      if (!this.currentVariant){
        currentSelectedColor = this.getColorsOptionInfo()[0];
      } else{
        currentSelectedColor = this.getColorsOptionInfo().find(colorVariant => this.currentVariant.title.includes(colorVariant));
      }
    }else{
      currentSelectedColor = 'default'
    }
    return currentSelectedColor.toLowerCase();
  }

  updateOptions() {
    var options = [];
    var renderOptions = this.querySelectorAll('.variant-option');
    renderOptions.forEach(element => {
      if (element.classList.contains('rounded')) {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
          options.push(Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value);
        });
      }
      else{
        options.push(element.querySelector('.select__select').value)
      }
    });
     this.options = options;
     return options;
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }
  
  toggleSlides(){   
    var sliderWrapArray = [...document.getElementsByClassName("slider-big-wrap")];
    var currentColor = this.getSelectedColor();
    sliderWrapArray.forEach((sliderWrap)=>{
      var mainSlider = sliderWrap.querySelector('main-product-slider-element');
      if(mainSlider.color == currentColor){
        var thumbsSlider = sliderWrap.querySelector('thumbs-product-slider-element');
        sliderWrap.classList.remove("hidden");
        if(mainSlider.isInitialized()){
          thumbsSlider?.updateSwiper();
          mainSlider?.updateSwiper();
        }else{
          thumbsSlider?.initSwiper();
          mainSlider?.initSwiper();
        }
      }else{
        sliderWrap.classList.add("hidden");
      }
    });
  }
  toggleGrids(){   
    var gridsArray = [...document.getElementsByClassName("product-grid--wrap")];
    gridsArray.forEach((slider)=>{
      var currentColor = this.getSelectedColor();
      if(slider.classList.contains(`${currentColor}-product-grid--wrap`)){
        slider.classList.remove("hidden");
      }else{
        slider.classList.add("hidden");
      }
    });
  }
  filterMedia() {
    if(window.gridProductMediaGallery){
     this.toggleGrids();
    }
      this.toggleSlides();
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => { parent.scroll(0, 0) });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-options', VariantOptions);

